FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */


    var ELEM = '[data-fd="popover"]';


    var defaults = {
        useparent: true,
        parentid: -1,
        type: 'click',
        callbackprefix: 1,
        tag: 47,
        noedit: false
    };


    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    function setEvents() {
        var NAMESPACE = me.getUID('CTRL_');

        $(document).off('click', ELEM);
        $(document).on('click.' + NAMESPACE, ELEM, clickPopover);
    }


    function getPopover(wireEvent, container) {
        var list = '';

        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        if (wireEvent) {
            setEvents();
        }


        if (list.length === 0) {
            return;
        }

        list.each(function (i, e) {
            var elem = $(e);

            var options = $.extend({}, defaults, elem.data());

            me.setControlItemOptions(elem, options);

            if (options.noedit) {
                elem.attr('readonly', true);
                elem.css({ cursor: 'default' });
            } else {
                elem.css({ cursor: 'pointer' });
            }
        });
    }


    function clickPopover(event) {
        event.stopPropagation();

        var e = $(this);

        e.data().element = e;

        var data = e.data();

        if (data.noedit) {
            return;
        }

        setHighlightRow(data);

        setCallback(e);
    }


    /* ========================================================================
     *  set highlight
     * ========================================================================
    */


    function setHighlightRow(data) {
        var highlightClass = "highlight-child-withborder";
        var elem = data.element;
        var tr = elem.parents('tr');

        if (tr.length > 0) {
            var table = tr.parents('table');

            table.find('tr').removeClass('static').removeClass('highlight-child-withborder');
            tr.addClass('static').addClass(highlightClass);
        }
    }


    function setCallback(e) {
        var data = e.data();

        me.setCallBackFromData(e, { e: data.element, value: true, tag: data.tag, parentid: data.parentid });
    }


    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    child.setPopover = function (wireEvent, container) {
        getPopover(wireEvent, container);
    };

    return child;
}(jQuery, FD));